import type { PaaRow } from "./types";

// "What changed" sends one AI call per superseded/baseline-overridden sheet —
// it's the client's OpenAI key, so a large set can cost real money. The UI only
// confirms before a run whose ESTIMATED cost exceeds this (small runs go straight
// through). ~$0.50 ≈ 200 sheets at the current per-sheet estimate.
export const CONFIRM_ABOVE_USD = 0.5;

// Rough per-sheet cost of the narrator call (gpt-5-mini incl. reasoning). Only
// used to give the confirm a ballpark figure. Calibrated against real runs
// (~$0.0025/sheet, e.g. 42 sheets ≈ $0.11); tune as more usage comes in.
export const EST_USD_PER_SHEET = 0.0025;

// Whether this row will actually be sent to the AI to be compared — mirrors the
// server's per-row rule: "O" rows are removed (no new page to diff), plain "N"
// rows are brand new (nothing to compare; they get the stock "New sheet added."
// note instantly), and a sheet with no id can't be compared. Rows whose note the
// user already typed are left alone. Everything else gets a real comparison.
// Used both to estimate cost AND to decide which rows show the "comparing…"
// indicator, so the two never disagree.
export function willAiCompare(row: PaaRow, userNoteIds: Set<string>): boolean {
  if (!row.sheetId.trim() || userNoteIds.has(row.id)) return false;
  if (row.action === "O") return false;
  if (row.action === "N" && !(row.compareWith ?? "").trim()) return false;
  return true;
}

// Count of sheets in `rows` that will incur an AI call.
export function aiSheetCount(rows: PaaRow[], userNoteIds: Set<string>): number {
  return rows.filter((r) => willAiCompare(r, userNoteIds)).length;
}
